import React, { useState } from 'react';
import './App.css';
import { LandingScreen } from './components/LandingScreen';
import { QueueScreen } from './components/QueueScreen';
import { UserQueueData, LastTicketData } from './types';

function App() {
  const [isLandingDone, setIsLandingDone] = useState(false);
  const [initialUserData, setInitialUserData] = useState<UserQueueData | null>(null);
  const [lastTicket, setLastTicket] = useState<number | null>(null);

  const handleContinue = () => {
    setIsLandingDone(true);
  };

  return (
      <div className="App">
        {!isLandingDone ? (
            <LandingScreen
                onContinue={handleContinue}
                onUserDataLoaded={setInitialUserData}
                onLastTicketLoaded={(value) => setLastTicket(value)}
            />
        ) : (
            <QueueScreen initialUserData={initialUserData} lastTicket={lastTicket} />
        )}
      </div>
  );
}

export default App;
